import React from 'react';
import { Link, Paper, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import { utilMethods } from '../../util/util.js';
import TowSheetDays from './TowSheetDays';
import { tokens } from '../../theme';

const InvoiceTableView = ({ invoiceList }) => (
    <TowSheetDays
        invoiceList={invoiceList}
        renderDay={(attachments) => (
            <Paper variant="outlined">
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>Invoice</TableCell>
                            <TableCell align="right">Files</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {utilMethods.sortInvoiceArray(Object.keys(attachments)).map((item) => {
                            const files = attachments[item.invNo] || [];
                            return (
                                <TableRow hover key={item.invNo}>
                                    <TableCell>
                                        {files.length ? (
                                            <Link
                                                component="button"
                                                underline="hover"
                                                onClick={() => window.open(files[0].attachmentURL)}
                                                sx={{ fontWeight: 600, display: 'inline-flex', alignItems: 'center', gap: 1 }}
                                            >
                                                <PictureAsPdfOutlinedIcon fontSize="small" sx={{ color: tokens.red }} />
                                                {item.invNo}
                                            </Link>
                                        ) : (
                                            item.invNo
                                        )}
                                    </TableCell>
                                    <TableCell align="right" sx={{ color: 'text.secondary' }}>
                                        {files.length}
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>
            </Paper>
        )}
    />
);

export default InvoiceTableView;
